import { styled } from "@mui/material/styles";
import { Box, Divider, Typography, Stepper, StepConnector, StepLabel } from "@mui/material";
import { stepConnectorClasses } from "@mui/material/StepConnector";

/* ---------------- PAGE WRAPPER ---------------- */
export const PageWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#F1F5F9",
  padding: "20px",

  [theme.breakpoints.down("sm")]: {
    padding: 0,
    alignItems: "stretch",
  },
}));

/* ---------------- FORM WRAPPER ---------------- */
export const FormWrapper = styled(Box)(({ theme }) => ({
  background: "#FFF",
  borderRadius: "12px",
  padding: "24px",
  width: "100%",
  maxWidth: "680px",
  maxHeight: "85vh",

  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  position: "relative",

  [theme.breakpoints.down("sm")]: {
    borderRadius: 0,
    padding: "20px 16px",
    maxHeight: "100vh",
  },
}));

/* ---------------- FORM CONTENT ---------------- */
export const FormContent = styled(Box)(({ theme }) => ({
  width: "100%",
  minHeight: "420px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "12px",

  [theme.breakpoints.up("md")]: {
    minHeight: "460px",
  },
}));

/* ---------------- ACTION BAR ---------------- */
export const ActionBar = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  marginTop: "20px",
  gap: "10px",

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: "12px",
  },
}));

/* ---------------- STEPPER (compacto e centralizado) ---------------- */
export const CompactStepper = styled(Stepper)({
  width: "100%",
  justifyContent: "center",

  "& .MuiStep-root": {
    flex: "0 0 auto",          // impede ocupar largura total
    margin: "0 12px",          // aproxima
  },
});

/* ---------------- NO LINE CONNECTOR ---------------- */
export const NoLineConnector = styled(StepConnector)(({ theme }) => ({
  [`& .${stepConnectorClasses.line}`]: {
    border: "none",
  },
}));

/* ---------------- STEP LABEL COLOR ---------------- */
export const PurpleStepLabel = styled(StepLabel)(({ theme }) => {
  const primaryMain =
    theme.vars?.palette?.primary?.main || theme.palette.primary.main;

  const primaryLight =
    theme.vars?.palette?.primary?.light || theme.palette.primary.light;

  return {
    "& .MuiStepIcon-root": {
      color: primaryLight,
    },
    "& .MuiStepIcon-root.Mui-active": {
      color: primaryMain,
    },
    "& .MuiStepIcon-root.Mui-completed": {
      color: primaryMain,
    },
    "& .MuiStepIcon-text": {
      fill: "#FFF",
    },
  };
});

/* ---------------- FORM DIVIDER ---------------- */
export const FormDivider = styled(Divider)({
  width: "90%",
  borderColor: "gray",
  margin: "15px 0",
});

/* ---------------- STEP DESCRIPTION ---------------- */
export const StepDescription = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: "#333",
  textAlign: "center",
  maxWidth: "80%",
  marginBottom: "15px",
  marginTop: '15px',

  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    maxWidth: "100%",
  },
}));

/* ---------------- STEP TITLE --------------------- */
export const StepTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginTop: "15px",  
  marginBottom: "15px",
  textAlign: "center",

  [theme.breakpoints.down("sm")]: {
    marginTop: "24px",
  },
}));
